import {
  AuthorityDetailAuthority,
  AuthorityDetailAuthorityFromJSON,
  AuthorityDetailCrossReferenceAuthority,
  AuthorityDetailCrossReferenceAuthorityFromJSON,
  AuthorityDetailTag,
  AuthorityDetailTagFromJSON,
  exists
} from '@/api'

export interface AuthorityDetail {
  authorities: AuthorityDetailAuthority[]
  authorityTags: AuthorityDetailTag[]
  crossReferenceAuthorities: AuthorityDetailCrossReferenceAuthority[]
  existsSubAuthority: boolean
  bibliographyCount: number
}

export const defaultAuthorityDetail = (): AuthorityDetail => ({
  authorities: [],
  authorityTags: [],
  crossReferenceAuthorities: [],
  existsSubAuthority: false,
  bibliographyCount: 0
})

export function AuthorityDetailFromJSON(json: any): AuthorityDetail {
  return {
    authorities: exists(json, 'authorities')
      ? json.authorities.map(AuthorityDetailAuthorityFromJSON)
      : [],
    authorityTags: exists(json, 'authority_tags')
      ? json.authority_tags.map(AuthorityDetailTagFromJSON)
      : [],
    crossReferenceAuthorities: exists(json, 'cross_reference_authorities')
      ? json.cross_reference_authorities.map(
          AuthorityDetailCrossReferenceAuthorityFromJSON
        )
      : [],
    existsSubAuthority: exists(json, 'exists_sub_authority')
      ? json.exists_sub_authority
      : false,
    bibliographyCount: exists(json, 'bibliography_count')
      ? json.bibliography_count
      : 0
  }
}
